import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend, Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

const MAX_POINTS = 60;

function Charts(props: {history: Record<string, number[]>, selected: string}) {

    const options = {
        animation: {
            duration: 0
        },
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            title: {
                display: false,
                text: props.selected,
            },
            filler: {
                propagate: true
            },
            legend: {
                display: false
            },
        },
        scales: {
            y: {
                beginAtZero: false,
                grace: '30%',
                grid: {
                    display: false,
                },
                display: false,
            },
            x: {
                grid: {
                    display: false,
                    drawTicks: true,
                },
                ticks: {
                    display: false
                }
            }
        },
        datasets: {
            line: {
                pointRadius: 0
            },
        },
    };

    // @ts-ignore
    const labels: string[] = [...Array(props.history[props.selected].length).keys()].map(i => `D${i}`).slice(-MAX_POINTS);
    const data = {
        labels,
        datasets: [
            {
                label: '',
                data: props.history[props.selected].slice(-MAX_POINTS),
                borderColor: 'rgba(0, 0, 0, 1)',
                borderWidth: 1.5,
                tension: 0,
                fill: {
                    target: 'origin',
                    above: 'rgba(0, 0, 0, 0.15)'
                }
            }
        ],
    };

    return (
        <div className="w-full absolute bottom-0">
            <Line data={data} options={options} />
        </div>
    );

}

export {Charts, MAX_POINTS};